import React from "react";

const Aux = (props) => props.children;

//export default class TimetableEntry extends React.Component {
export const TimetableEntry = ({ journey }) => {
  if (journey.iscancel) {
    return (
      <Aux>
        <tr className="cancel">
          <td className="TableZeit">{journey.fpTime}</td>
          <td className="TableZugNummer">
            {journey.prod
              .substring(0, journey.prod.indexOf("#"))
              .replace(" ", "")}
          </td>
          <td className="TableBahnof"> {journey.dir}</td>
          <td className="TableGleis">Gleis {journey.platform}</td>
        </tr>
        {journey.cleanMassageTitel || journey.cleanMassage ? (
          <tr>
            <td colSpan="4">
              {journey.cleanMassageTitel + " " + journey.cleanMassage}
            </td>
          </tr>
        ) : null}
      </Aux>
    );
  }

  if (journey.isDelayed) {
    let delay = "+" + journey.delayInMin + "'";

    return (
      <Aux>
        <tr>
          <td className="TableZeit">
            {journey.fpTime} <span className="timeDelay">{delay}</span>
          </td>
          <td className="TableZugNummer">
            {journey.prod
              .substring(0, journey.prod.indexOf("#"))
              .replace(" ", "")}
          </td>
          <td className="TableBahnof"> {journey.dir}</td>
          <td className="TableGleis">Gleis {journey.platform}</td>
        </tr>
        {journey.cleanMassageTitel || journey.cleanMassage ? (
          <tr>
            <td colspan="4">
              {journey.cleanMassageTitel + ": " + journey.cleanMassage}
            </td>
          </tr>
        ) : null}
      </Aux>
    );
  }

  return (
    <tr>
      <td className="TableZeit">{journey.fpTime}</td>
      <td className="TableZugNummer">
        {journey.prod.substring(0, journey.prod.indexOf("#")).replace(" ", "")}
      </td>
      <td className="TableBahnof"> {journey.dir}</td>
      <td className="TableGleis">Gleis {journey.platform}</td>
    </tr>
  );
};



// WEBPACK FOOTER //
// ./src/timetableEnty.js